__webpack_require__.p = "https://assets.khanoumi.com/4.190.0.1/_next/";